import React from 'react'
import { Navigate, Outlet, useRoutes } from 'react-router-dom'
import { AppLayout, LoginLayout } from 'components/layout'
import Home from 'views/home'
import Profile from 'views/auth/Profile'
import Login from 'views/auth/Login'
import ForgotPassword from 'views/auth/ForgotPassword'
import ResetPassword from 'views/auth/ResetPassword'
import Verify from 'views/auth/Verify'
import Error from 'views/Error'
import SalesOrders from 'views/maestro/sales-orders'
import CreateSalesOrders from 'views/maestro/sales-orders/create'
import InboundDelivery from 'views/maestro/inbound-delivery'
import CreateInboundDelivery from 'views/maestro/inbound-delivery/create'
import Products from 'views/maestro/products'
import CreateProducts from 'views/maestro/products/create'
import DashboardInbound from 'views/dashboards/inbound'
import DashboardOutbound from 'views/dashboards/outbound'
import DashboardInventory from 'views/dashboards/inventory'
import DashboardPerformance from 'views/dashboards/performance'
import DashboardFinancials from 'views/dashboards/financials'
import Asn from 'views/meson-wms/asn'
import ViewAsn from 'views/meson-wms/asn/view'
import Shipments from 'views/meson-wms/shipments'
import ViewShipments from 'views/meson-wms/shipments/view'
import StockHoldings from 'views/meson-wms/stock-holdings'
import ViewStockHoldings from 'views/meson-wms/stock-holdings/view'
import StockTransactions from 'views/meson-wms/stock-transactions'
import MesonInsightsInbound from 'views/meson-insights/inbound'
import CreateMesonInsightsInbound from 'views/meson-insights/inbound/create'
import MesonInsightsOutbound from 'views/meson-insights/outbound'
import CreateMesonInsightsOutbound from 'views/meson-insights/outbound/create'
import MesonInsightsInventory from 'views/meson-insights/inventory'
import CreateMesonInsightsInventory from 'views/meson-insights/inventory/create'
import MesonInsightsPerformance from 'views/meson-insights/performance'
import CreateMesonInsightsPerformance from 'views/meson-insights/performance/create'
import MesonInsightsFinancials from 'views/meson-insights/financials'
import CreateMesonInsightsFinancials from 'views/meson-insights/financials/create'
import Company from 'views/company-management/company'
import CreateCompany from 'views/company-management/company/create'
import IntegrationType from 'views/company-management/maestro-integration-type'
import CreateIntegrationType from 'views/company-management/maestro-integration-type/create'
import Integration from 'views/company-management/maestro-integration'
import CreateIntegration from 'views/company-management/maestro-integration/create'
import AccessKey from 'views/company-management/access-key'
import CreateAccessKey from 'views/company-management/access-key/create'
import MachshipIntegration from 'views/company-management/machship-integration'
import CreateMachshipIntegration from 'views/company-management/machship-integration/create'
import XeroIntegration from 'views/company-management/xero-integration'
import CreateXeroIntegration from 'views/company-management/xero-integration/create'
import Roles from 'views/user-management/roles'
import CreateRoles from 'views/user-management/roles/create'
import Users from 'views/user-management/users'
import CreateUsers from 'views/user-management/users/create'
import Customers from 'views/customers'
import CreateCustomers from 'views/customers/create'
import Machship from 'views/machship'
import CreateMachship from 'views/machship/create'
import Xero from 'views/xero'
import CreateXero from 'views/xero/create'
// import Reports from 'views/reports'
// import CreateReports from 'views/reports/create'
import Access from 'views/access'
import TransLog from 'views/maestro/trans-log'
import CronJobs from 'views/maestro/cron-jobs'
import FileDirectory from 'views/maestro/file-directory'

export default function Router() {
    return useRoutes([
        {
            path: '/',
            element: <AppLayout />,
            children: [
                //home
                { path: '/', element: <Home /> },

                //profile
                { path: '/profile', element: <Profile /> },

                //sales orders
                {
                    path: '/maestro/sales-orders',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <SalesOrders /> },
                        { path: 'create', element: <CreateSalesOrders /> },
                        { path: ':id/edit', element: <CreateSalesOrders /> },
                    ],
                },

                //inbound delivery
                {
                    path: '/maestro/inbound-delivery',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <InboundDelivery /> },
                        { path: 'create', element: <CreateInboundDelivery /> },
                        { path: ':id/edit', element: <CreateInboundDelivery /> },
                    ],
                },

                //products
                {
                    path: '/maestro/products',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Products /> },
                        { path: 'create', element: <CreateProducts /> },
                        { path: ':id/edit', element: <CreateProducts /> },
                    ],
                },

                //trans-log
                {
                    path: '/maestro/transaction-log',
                    element: <Outlet />,
                    children: [{ path: '', element: <TransLog /> }],
                },

                //cron-jobs
                {
                    path: '/maestro/cron-jobs',
                    element: <Outlet />,
                    children: [{ path: '', element: <CronJobs /> }],
                },

                //file-directory
                {
                    path: '/maestro/file-directory',
                    element: <Outlet />,
                    children: [{ path: '', element: <FileDirectory /> }],
                },

                //dashboard inbound
                {
                    path: '/dashboards/inbound-dashboard',
                    element: <Outlet />,
                    children: [{ path: '', element: <DashboardInbound /> }],
                },

                //dashboard outbound
                {
                    path: '/dashboards/outbound-dashboard',
                    element: <Outlet />,
                    children: [{ path: '', element: <DashboardOutbound /> }],
                },

                //dashboard inventory
                {
                    path: '/dashboards/inventory-dashboard',
                    element: <Outlet />,
                    children: [{ path: '', element: <DashboardInventory /> }],
                },

                //dashboard performance
                {
                    path: '/dashboards/performance-dashboard',
                    element: <Outlet />,
                    children: [{ path: '', element: <DashboardPerformance /> }],
                },

                //dashboard financials
                {
                    path: '/dashboards/financials-dashboard',
                    element: <Outlet />,
                    children: [{ path: '', element: <DashboardFinancials /> }],
                },

                //asn
                {
                    path: '/meson-wms/asn',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Asn /> },
                        { path: ':id/view', element: <ViewAsn /> },
                    ],
                },

                //shipments
                {
                    path: '/meson-wms/shipments',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Shipments /> },
                        { path: ':id/view', element: <ViewShipments /> },
                    ],
                },

                //stock holdings
                {
                    path: '/meson-wms/stock-holdings',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <StockHoldings /> },
                        { path: ':id/view', element: <ViewStockHoldings /> },
                    ],
                },

                //stock transactions
                {
                    path: '/meson-wms/stock-transactions',
                    element: <Outlet />,
                    children: [{ path: '', element: <StockTransactions /> }],
                },

                //meson insights inbound
                {
                    path: '/meson-insights/inbound',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MesonInsightsInbound /> },
                        { path: 'create', element: <CreateMesonInsightsInbound /> },
                        { path: ':id/edit', element: <CreateMesonInsightsInbound /> },
                    ],
                },

                //meson insights outbound
                {
                    path: '/meson-insights/outbound',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MesonInsightsOutbound /> },
                        { path: 'create', element: <CreateMesonInsightsOutbound /> },
                        { path: ':id/edit', element: <CreateMesonInsightsOutbound /> },
                    ],
                },

                //meson insights inventory
                {
                    path: '/meson-insights/inventory',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MesonInsightsInventory /> },
                        { path: 'create', element: <CreateMesonInsightsInventory /> },
                        { path: ':id/edit', element: <CreateMesonInsightsInventory /> },
                    ],
                },

                //meson insights performance
                {
                    path: '/meson-insights/performance',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MesonInsightsPerformance /> },
                        { path: 'create', element: <CreateMesonInsightsPerformance /> },
                        { path: ':id/edit', element: <CreateMesonInsightsPerformance /> },
                    ],
                },

                //meson insights financials
                {
                    path: '/meson-insights/financials',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MesonInsightsFinancials /> },
                        { path: 'create', element: <CreateMesonInsightsFinancials /> },
                        { path: ':id/edit', element: <CreateMesonInsightsFinancials /> },
                    ],
                },

                //company
                {
                    path: '/company-management/company',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Company /> },
                        { path: 'create', element: <CreateCompany /> },
                        { path: ':id/edit', element: <CreateCompany /> },
                    ],
                },

                //integration type
                {
                    path: '/company-management/integration-type',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <IntegrationType /> },
                        { path: 'create', element: <CreateIntegrationType /> },
                        { path: ':id/edit', element: <CreateIntegrationType /> },
                    ],
                },

                //integration
                {
                    path: '/company-management/integration',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Integration /> },
                        { path: 'create', element: <CreateIntegration /> },
                        { path: ':id/edit', element: <CreateIntegration /> },
                    ],
                },

                //access key
                {
                    path: '/company-management/access-key',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <AccessKey /> },
                        { path: 'create', element: <CreateAccessKey /> },
                        { path: ':id/edit', element: <CreateAccessKey /> },
                    ],
                },

                //machship integration
                {
                    path: '/company-management/machship-integration',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <MachshipIntegration /> },
                        { path: 'create', element: <CreateMachshipIntegration /> },
                        { path: ':id/edit', element: <CreateMachshipIntegration /> },
                    ],
                },

                //xero integration
                {
                    path: '/company-management/xero-integration',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <XeroIntegration /> },
                        { path: 'create', element: <CreateXeroIntegration /> },
                        { path: ':id/edit', element: <CreateXeroIntegration /> },
                    ],
                },

                //roles
                {
                    path: '/company-management/roles',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Roles /> },
                        { path: 'create', element: <CreateRoles /> },
                        { path: ':id/edit', element: <CreateRoles /> },
                    ],
                },

                //users
                {
                    path: '/company-management/users',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Users /> },
                        { path: 'create', element: <CreateUsers /> },
                        { path: ':id/edit', element: <CreateUsers /> },
                    ],
                },

                //customers
                {
                    path: '/company-management/customers',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Customers /> },
                        { path: 'create', element: <CreateCustomers /> },
                        { path: ':id/edit', element: <CreateCustomers /> },
                    ],
                },

                //machship
                {
                    path: '/transport/machship',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Machship /> },
                        { path: 'create', element: <CreateMachship /> },
                        { path: ':id/edit', element: <CreateMachship /> },
                    ],
                },

                //xero
                {
                    path: '/finacials/xero',
                    element: <Outlet />,
                    children: [
                        { path: '', element: <Xero /> },
                        { path: 'create', element: <CreateXero /> },
                        { path: ':id/edit', element: <CreateXero /> },
                    ],
                },

                //access
                {
                    path: '/company-management/access',
                    element: <Outlet />,
                    children: [{ path: '', element: <Access /> }],
                },

                //reports
                // {
                //     path: '/reports',
                //     element: <Outlet />,
                //     children: [
                //         { path: '', element: <Reports /> },
                //         { path: 'create', element: <CreateReports /> },
                //         { path: ':id/edit', element: <CreateReports /> },
                //     ],
                // },
            ],
        },
        {
            path: '/',
            element: <LoginLayout />,
            children: [
                { path: '/login', element: <Login /> },
                { path: '/forgot-password', element: <ForgotPassword /> },
                { path: '/reset-password/:uid/:token', element: <ResetPassword /> },
                { path: '/verify', element: <Verify /> },
            ],
        },
        { path: 'error', element: <Error /> },
        { path: '*', element: <Navigate to="/error" replace /> },
    ])
}
